import Typography from "Components/CommonComponents/Typography";
import { UserInfoContext } from "Context/CommonContext";
import { useContext } from "react";
// import { Col, Row } from "reactstrap";
import "./index.css";
import { IUserInfo } from "utilFunctions/CommonInterfaces/userInterface";
import PDFView from "Pages/AssetView/PDFView";
import VideoView from "Pages/AssetView/VideoView";
import PPTView from "Pages/AssetView/PPTView";
import "Components/CommonComponents/DocumentViewer.css";

interface IAssetInfo {
  assetId?: number | string;
  courseId?: number | string;
  type?: string;
  desc?: string;
  title?: string;
}
export interface IAssetdata {
  assetId?: number | string;
  courseId?: number | string;
  type?: string;
  desc?: string;
  url?: string;
  title?: string;
}
const AssetView = ({ assetId, courseId, type, title, desc }: IAssetInfo) => {
  const userInfo = useContext<IUserInfo>(UserInfoContext);
  const isDocument = ["Faculty_Ebook", "Ebook", "Faculty_ppt", "PPT"].includes(
    type || ""
  );
  console.log(userInfo, assetId, "scheduleAssetData", type);

  return (
    <div
      className={`modern-asset-view-container ${
        isDocument ? "document-asset-view-container" : ""
      }`}
    >
      <div className="modern-asset-content">
        {type == "Faculty_Ebook" || type == "Ebook" ? (
          <PDFView assetId={assetId} courseId={courseId} />
        ) : null}
        {type == "Faculty_Video" || type == "Video" || type == "Audio" ? (
          <div className="modern-video-wrapper">
            <div className="video-player-container">
              <VideoView assetId={assetId} courseId={courseId} />
            </div>
          </div>
        ) : null}
        {type == "Faculty_ppt" || type == "PPT" ? (
          <PPTView assetId={assetId} courseId={courseId} />
        ) : null}
      </div>

      <div className="modern-asset-info">
        <div className="asset-info-item">
          <Typography variant="subheading2" color="black">
            Content Title:&nbsp;
          </Typography>
          <Typography variant="h5" color="black">
            {title}
          </Typography>
        </div>
        {desc && (
          <div className="asset-info-item">
            <Typography variant="subheading2" color="black">
              Description:&nbsp;
            </Typography>
            <Typography variant="h5" color="black">
              {desc}
            </Typography>
          </div>
        )}
      </div>
    </div>
  );
};

export default AssetView;
